import { useContext, useEffect, useState } from "react";
import { EmpiricaContext, GlobalContext, NSContext, OnPlayerIDContext, } from "./components/Context";
export function useGlobal() {
    const globalCtx = useContext(GlobalContext);
    const [glob, setGlobal] = useState({ data: {} });
    let globalUnsub = null;
    useEffect(() => {
        if (!globalCtx) {
            setGlobal({ data: {} });
            if (globalUnsub) {
                globalUnsub();
                globalUnsub = null;
            }
            return;
        }
        globalUnsub = globalCtx?.subscribe((vals) => {
            setGlobal({ data: vals || {} });
        });
        return globalUnsub;
    }, [globalCtx]);
    return glob.data;
}
const defaultConsentKey = "emp:part:consent";
function consentKey(ns) {
    return `${defaultConsentKey}${ns ? `:${ns}` : ""}`;
}
function getConsented(ns) {
    return Boolean(window.localStorage[consentKey(ns)]);
}
export function useConsent() {
    const nsCtx = useContext(NSContext);
    const [consented, setConsented] = useState(getConsented(nsCtx));
    useEffect(() => {
        setConsented(getConsented(nsCtx));
    }, [nsCtx]);
    function onConsent() {
        window.localStorage[consentKey(nsCtx)] = true;
        setConsented(true);
    }
    return [consented, onConsent];
}
export function usePlayerID() {
    const opiCtx = useContext(OnPlayerIDContext);
    const playerCtx = useContext(EmpiricaContext);
    const [hasPlayer, setPlayer] = useState(Boolean(playerCtx));
    useEffect(() => setPlayer(Boolean(playerCtx)), [playerCtx]);
    return [hasPlayer, opiCtx];
}
export function useGame() {
    const playerCtx = useContext(EmpiricaContext);
    const [game, setGame] = useState({
        game: playerCtx?.game || null,
    });
    let gameUnsub = null;
    useEffect(() => {
        if (!playerCtx) {
            setGame({ game: null });
            if (gameUnsub) {
                gameUnsub();
                gameUnsub = null;
            }
            return;
        }
        gameUnsub = playerCtx?.gameSub.subscribe((game) => {
            setGame({ game });
        });
        return gameUnsub;
    }, [playerCtx]);
    return game.game;
}
export function useRound() {
    const playerCtx = useContext(EmpiricaContext);
    const [round, setRound] = useState({
        round: playerCtx?.round || null,
    });
    let roundUnsub = null;
    useEffect(() => {
        if (!playerCtx) {
            setRound({ round: null });
            if (roundUnsub) {
                roundUnsub();
                roundUnsub = null;
            }
            return;
        }
        roundUnsub = playerCtx?.roundSub.subscribe((round) => {
            setRound({ round });
        });
        return roundUnsub;
    }, [playerCtx]);
    return round.round;
}
export function useStage() {
    const playerCtx = useContext(EmpiricaContext);
    const [stage, setStage] = useState({
        stage: playerCtx?.stage || null,
    });
    let stageUnsub = null;
    useEffect(() => {
        if (!playerCtx) {
            setStage({ stage: null });
            if (stageUnsub) {
                stageUnsub();
                stageUnsub = null;
            }
            return;
        }
        stageUnsub = playerCtx?.stageSub.subscribe((stage) => {
            setStage({ stage });
        });
        return stageUnsub;
    }, [playerCtx]);
    return stage.stage;
}
export function useStageTimer() {
    const stage = useStage();
    const [remaining, setRemaining] = useState({
        remaining: stage?.remaining || null,
    });
    let unsub = null;
    useEffect(() => {
        if (!stage) {
            setRemaining({ remaining: null });
            if (unsub) {
                unsub();
                unsub = null;
            }
            return;
        }
        unsub = stage.remainingW.subscribe((remaining) => {
            setRemaining({ remaining });
        });
        return unsub;
    }, [stage]);
    return remaining.remaining;
}
export function usePlayer() {
    const playerCtx = useContext(EmpiricaContext);
    const [player, setPlayer] = useState({
        player: playerCtx?.player || null,
    });
    let playerUnsub = null;
    useEffect(() => {
        if (!playerCtx) {
            setPlayer({ player: null });
            if (playerUnsub) {
                playerUnsub();
                playerUnsub = null;
            }
            return;
        }
        playerUnsub = playerCtx?.playerSub.subscribe((player) => {
            setPlayer({ player });
        });
        return playerUnsub;
    }, [playerCtx]);
    return player.player;
}
export function usePlayers() {
    const playerCtx = useContext(EmpiricaContext);
    const [players, setPlayers] = useState({
        players: playerCtx?.players || null,
    });
    let playersUnsub = null;
    useEffect(() => {
        if (!playerCtx) {
            setPlayers({ players: null });
            if (playersUnsub) {
                playersUnsub();
                playersUnsub = null;
            }
            return;
        }
        playersUnsub = playerCtx?.playersSub.subscribe((players) => {
            setPlayers({ players });
        });
        return playersUnsub;
    }, [playerCtx]);
    return players.players;
}
